import { useEffect, useRef, useState } from 'react'

// Keeps at most one card of a list with its quick add-to-cart panel open (ReflectionCard `isPanelOpen`).
// A click outside the open card closes its panel. The card marks its own clicks through React (`onCardPointerDown`
// as the card's onPointerDown), so clicks in its portals (the variant select's options, the bottom sheet or dialog
// with the form, the kit editor) count as inside too: React events bubble through portals, and React handles them
// before this document listener.
const useOpenCardPanel = () => {
  const [openPanelSpecId, setOpenPanelSpecId] = useState<string | null>(null)
  const pointerDownInOpenCardRef = useRef(false)
  useEffect(() => {
    if (!openPanelSpecId) return undefined
    const handlePointerDown = () => {
      if (!pointerDownInOpenCardRef.current) setOpenPanelSpecId(null)
      pointerDownInOpenCardRef.current = false
    }
    document.addEventListener('pointerdown', handlePointerDown)
    return () => document.removeEventListener('pointerdown', handlePointerDown)
  }, [openPanelSpecId])

  const onCardPointerDown = (specId: string) => () => {
    if (openPanelSpecId === specId) pointerDownInOpenCardRef.current = true
  }
  const onTogglePanel = (specId: string) => (open: boolean) => setOpenPanelSpecId(open ? specId : null)

  return { openPanelSpecId, onCardPointerDown, onTogglePanel }
}

export default useOpenCardPanel
